import LocalizedStrings from 'localized-strings';

import { formatDate } from 'helpers/date';
import logger from 'helpers/logger';

const locales = new LocalizedStrings({
  en: {
    everyMonth: 'Monthly on the {0}',
    everyWeek: 'Weekly on {0}s',
    everyYear: 'Every {0} {1}',
    once: 'Once on {0}',
  },
  fr: {
    everyMonth: 'Tous les {0} du mois',
    everyWeek: 'Tous les {0}s',
    everyYear: 'Chaque {1} {0}',
    once: 'Une fois le {0}',
  },
});

export const getLocaleFromFrequency = (frequency: string): string => {
  const [, firstOccurrence, periodicity] = frequency.split('/');
  if (!firstOccurrence || !periodicity) {
    logger.error(`Can't parse frequency: ${frequency}`);
    return '';
  }

  const firstOccurrenceDate = new Date(firstOccurrence);
  const lang = locales.getLanguage();

  switch (periodicity) {
    case 'P??':
      return locales.formatString(
        locales.once,
        formatDate(firstOccurrenceDate, 'PPP'),
      );
    case 'P1W':
      return locales.formatString(
        locales.everyWeek,
        formatDate(firstOccurrenceDate, 'eeee'),
      );
    case 'P1M':
      return locales.formatString(
        locales.everyMonth,
        formatDate(firstOccurrenceDate, lang === 'fr' ? 'd' : 'do'),
      );
    case 'P1Y': {
      return locales.formatString(
        locales.everyYear,
        formatDate(firstOccurrenceDate, 'LLLL'),
        formatDate(firstOccurrenceDate, lang === 'fr' ? 'd' : 'do'),
      );
    }
    default:
      return '';
  }
};
